// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","headline":"App_headline__dnuSL"};